import React, { Fragment, PureComponent } from 'react';
import PropTypes from 'prop-types';
import TextField from '@material-ui/core/TextField';
import debounce from 'lodash/debounce';
import classNames from 'classnames';

class PageSelector extends PureComponent {
    constructor(props) {
        super(props);
        this.delayChangePage = debounce(this.delayChangePage, 650);
        let pageValue = this.props.currentPage !== 0 ? this.props.currentPage : 0;
        this.state = {
            pageValue: pageValue
        }
    }

    changePageManually = (value) => {
        if (value < 0) return;
        this.setState({ pageValue: parseInt(value) });
        this.delayChangePage(parseInt(value));
    }

    delayChangePage = (val) => {
        this.props.onCurrentPageChange(val);
    }

    render() {
        let { classes } = this.props;
        return (
            <div style={{ display: 'flex' }}>
                <span className={classNames(classes.pageSizeSelector)}>
                    Enter page number:
                </span>
                <TextField
                    variant="outlined"
                    onChange={(e) => this.changePageManually(e.target.value - 1)}
                    value={this.state.pageValue + 1}
                    type="number"
                    style={{ minWidth: '25px', maxWidth: '50px' }}
                />
            </div>
        )
    }
}

PageSelector.propTypes = {
    currentPage: PropTypes.number,
    onCurrentPageChange: PropTypes.func,
    classes: PropTypes.object
};

export default PageSelector;




// WEBPACK FOOTER //
// ./src/main/content/common/data-table/PageSelector.js